import config from '@/config';
import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import axios, { isAxiosError } from 'axios';
import { onServerPrefetch } from 'vue';
import { useRouter, type Router } from 'vue-router';
import { error } from '../routes';

let router: Router;

export const getAgentQueryKey = (agentId: string) => ['agent', agentId];
export const agentQuery = async (agentId: string) => {
  const url = isSSR ? `${config.BACKEND.URL}/agents/${agentId}` : `/api/agents/${agentId}`;
  logger.info(`Fetching agent data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      logger.info('Agent: Got response');
      return res.data;
    })
    .catch((err: unknown) => {
      if (isAxiosError(err) && err.response?.status === 404) {
        if (router) {
          void router.replace({ path: error.path, query: { errorPageName: 'agent' } }); // On client side routing, redirect to the error page
        }
      }
      logger.info('Agent: Got error:', err);
      return Promise.reject(err);
    });
};

export default function useAgentData(agentId: string) {
  router = useRouter();
  logger.info('useAgentData with agent: ' + agentId);
  const query = useQuery({
    queryKey: [getAgentQueryKey, agentId],
    queryFn: () => agentQuery(agentId),
  });

  onServerPrefetch(async () => {
    const queryClient = useQueryClient();
    await queryClient.prefetchQuery({ queryKey: [getAgentQueryKey, agentId] });
  });

  return query;
}
